import request from "./request";

// 客户详情
export function userinfo() {
  return request({
    url: "/apipad.php/User/user_detail",
    method: "post",
  });
}

export function systemDetial() {
  return request({
    url: "/apipad.php/User/config_detail",
    method: "post",
  });
}

export function update(data) {
  return request({
    url: "/apipad.php/User/baseconfig_update",
    method: "post",
    data,
  });
}

export function changePwd(data) {
  return request({
    url: "/apipad.php/User/pass_update",
    method: "post",
    data,
  });
}

export function changeManagerPwd(data) {
  return request({
    url: "/apipad.php/User/pass_updatec",
    method: "post",
    data,
  });
}

export function getQRCode() {
  return request({
    url: "/apipad.php/User/qorde_detail",
    method: "post",
  });
}

export function updateQRCode(data) {
  return request({
    url: "/apipad.php/User/qorde_update",
    method: "post",
    data,
  });
}

// banner 管理
// 添加banner
export function addBanner(data) {
  return request({
    url: "/apipad.php/User/add_img_detail",
    method: "post",
    data,
  });
}

// 修改banner
export function editBanner(data) {
  return request({
    url: "/apipad.php/User/edit_img_detail",
    method: "post",
    data,
  });
}

// 删除图片
export function deleteBanner(data) {
  return request({
    url: "/apipad.php/User/vdel_img_detail",
    method: "post",
    data,
  });
}

// banner详情
export function getBanner(data) {
  return request({
    url: "/apipad.php/User/img_detail",
    method: "post",
    data,
  });
}

// 现货热销
export function getHotList() {
  return request({
    url: "/apipad.php/User/Home",
    method: "post",
  });
}

// 新增或修改首页装修
export function homeDecoration(data) {
  return request({
    url: "/apipad.php/User/addhome",
    method: "post",
    data,
  });
}

// 获取首页装修的详情
export function homeDecorationDetails() {
  return request({
    url: "/apipad.php/User/detailhome",
    method: "post",
  });
}
// 获取公用装修模版
export function modelList() {
  return request({
    url: "/apipad.php/User/templatehome",
    method: "post",
  });
}

// 获取商品分类列表
export function CategoryList(data) {
  return request({
    url: "/apipad.php/MysqlCate/index",
    method: "post",
    data,
  });
}

// 获取热销商品
export function GetHotItems(data) {
  return request({
    url: "/apipad.php/User/home",
    method: "post",
    data,
  });
}





// 团队等级设置
// 列表
export function getLevelList(data) {
  return request({
    url: "/apipad.php/Company/indextuanGrade",
    method: "post",
    data,
  });
}

// 新增等级
export function addLevelList(data) {
  return request({
    url: "/apipad.php/Company/addtuanGrade",
    method: "post",
    data,
  });
}
// 删除等级
export function removeLevelList(data) {
  return request({
    url: "/apipad.php/Company/deltuanGrade",
    method: "post",
    data,
  });
}
